import React, { useMemo } from 'react';
import { useAccountTimeRange } from '@ubeya/shared-web/hooks/useAccountTimeRange';
import { Invoices } from 'shared/components';
import CRMInvoiceModal from './CRMInvoiceModal';
import useClientInvoice from 'crm/hooks/useClientInvoice';

const ClientInvoices = ({ clientId, clientBranchesIds, isShown, clientName }) => {
  const [timeRange, setTimeRange] = useAccountTimeRange();

  const { payroll, payrollTotal, isLoading } = useClientInvoice({
    clientId,
    timeRange,
    enabled: isShown
  });

  const invoicesModalParams = useMemo(
    () => ({
      payroll,
      clientBranchesIds,
      filePrefix: clientName
    }),
    [clientBranchesIds, payroll, clientName]
  );

  return (
    <Invoices
      payroll={payroll}
      payrollTotal={payrollTotal}
      isLoading={isLoading}
      setTimeRange={setTimeRange}
      timeRange={timeRange}
      clientId={clientId}
      InvoicesModalComponent={CRMInvoiceModal}
      invoicesModalParams={invoicesModalParams}
      useClientProject={false}
    />
  );
};

export default React.memo(ClientInvoices);
